import { useEffect } from 'react'
import { datadogRum } from '@datadog/browser-rum'

/**
 * @deprecated Prefer `useFullscreen` from `@dhl/use-fullscreen`
 */
export const useFullscreenLock = (active = true): void => {
  const enabled =
    active &&
    navigator.userAgent.toLowerCase().includes('android') &&
    !!document.documentElement.requestFullscreen &&
    document.exitFullscreen

  useEffect(() => {
    if (enabled) {
      document.documentElement.requestFullscreen().catch((e) => {
        datadogRum.addAction('fullscreen-lock', { message: `Failed to lock: ${e.message}` })
      })

      return () => {
        document.exitFullscreen().catch((e) => {
          datadogRum.addAction('fullscreen-lock', { message: `Failed to unlock: ${e.message}` })
        })
      }
    }

    return () => {}
  }, [enabled])
}
